import * as React from 'react'
import { useDispatch } from 'react-redux'

import { getBopProfitAndLoss } from 'slices/bopSlice'
import { getTenantSummary } from 'slices/tenantsSlice'

import { Pivot, PivotItem } from 'components/common'

import useDateQuery from 'hooks/useDateQuery'

import BopMonitoringProfitAndLoss from './BopMonitoringProfitAndLoss'
import BopMonitoringSummary from './BopMonitoringSummary'
import Dashboard from './Dashboard'

const BopMonitoring: React.FC = () => {
  const dispatch = useDispatch()
  const date = useDateQuery()

  // ダッシュボード収支モニタリング取得
  React.useEffect(() => {
    dispatch(getBopProfitAndLoss(date))
    dispatch(getTenantSummary(date, { dashboardFilter: true }))
  }, [dispatch, date])

  return (
    <Dashboard onInterval={() => dispatch(getBopProfitAndLoss(date))}>
      <Pivot>
        {[
          { header: 'サマリー', key: 'summary' },
          { header: '損益詳細', key: 'profit_and_loss_detail' },
        ].map(({ header, key }) => (
          <PivotItem headerText={header} key={key}>
            {key === 'summary' ? (
              <BopMonitoringSummary />
            ) : key === 'profit_and_loss_detail' ? (
              <BopMonitoringProfitAndLoss />
            ) : null}
          </PivotItem>
        ))}
      </Pivot>
    </Dashboard>
  )
}

export default BopMonitoring
